import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Spin from 'antd/lib/spin';
import NmckMedicalDevicesCalculationInfo from '../../blocks/PageInfo/NmckGroupInfo/NmckMedicalDevicesCalculationInfo';
import style from './index.module.scss';
import api from '../../../helpers/api';

const NmckMedicalDevicesCalculation: React.FC = () => {
  const [isLoading, setLoading] = useState<boolean>(false);
  const [url, setUrl] = useState<string | null>(null);

  const path = useHistory().location.pathname;

  useEffect(() => {
    (async () => {
      setLoading(true);
      const pathParams = path.split('/nmck/')[1];
      if (path === '/nmck') {
        const res = await api.getUrlIframe('okpd2');
        setUrl(res.url);
        setLoading(false);
      } else {
        const res = await api.getUrlIframe(pathParams);
        setUrl(res.url);
        setLoading(false);
      }
    })();
  }, [path]);

  return (
    <>
      <div className={style.container}>
        <NmckMedicalDevicesCalculationInfo />
      </div>
      <div className={style.frame}>
        {!isLoading && url ? (
          <iframe title="MNCK" width="100%" height="100%" src={url} />
        ) : (
          <div className={style.spin}>
            <Spin />
          </div>
        )}
      </div>
    </>
  );
};

export default NmckMedicalDevicesCalculation;
